import { Record as record } from 'immutable';

import ValidationMixin from './ValidationMixin';
import validation from '../validation';

const defaults = {
    ticket: null,
    name: ''
};

class TicketPassenger extends record(defaults) {

    static fromJSON(json = {}) {
        return new TicketPassenger(json);
    }

    getSchema () {
        return {
            ticket: validation.requiredString(),
            name: validation.requiredString(2)
        };
    }

    toString () {
        return `${this.ticket} - ${this.name}`;
    }
}

Object.assign(TicketPassenger.prototype, ValidationMixin);

export default TicketPassenger;
